import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { _datiDetail } from '../../components/detail/detail.component';

@Component({
  selector: 'app-ana-smaltitori',
  templateUrl: './ana-smaltitori.component.html',
  styleUrls: ['./ana-smaltitori.component.css']
})
export class AnaSmaltitoriComponent implements OnInit {


  @Input() itemData //Tab Data in entryComponent



  id;
  passaDettagli: _datiDetail[]=[
    {chiave:"id_anagrafica", titolo:'Unità Locali', api:'unitalocali'},
    {chiave:"id_anagrafica", titolo:'Automezzi', api:'automezzi'},
  ];
  filterKey: any;
  ApiCall: any;

  constructor(private router:Router, private route: ActivatedRoute) { }

  ngOnInit() {
   
    /****Se apro form in EntryComponent Dinamico */
    if(this.itemData){
      console.log(this.itemData)
      /*this.SubjectCall = this.itemData[0].SubjectCall;*/
      this.ApiCall = this.itemData[0].ApiCall;
      this.filterKey = this.itemData[0].filterKey;
      //this.typeTabbed = true;
      
    }


  }

  sedeSelect(event){
    
    console.log(event); // Record elezionato
   // alert(event.id);
}

logga(event){

}

}
